import Drawer from "./Drawer";
import Icon from "./Icon";
import { formatDate } from "../utils/formatters";

// Lists the calendar notes covering a single day. canManage = the viewer owns
// these notes (employee) and may add/edit/delete; otherwise read-only (admin
// viewing everyone's notes — author name is shown).
export default function DayNotesDrawer({ open, date, notes = [], canManage = false, onClose, onAdd, onEdit, onDelete }) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={date ? date.format("ddd, DD MMM YYYY") : "Notes"}
      subtitle={`${notes.length} note${notes.length === 1 ? "" : "s"}`}
      footer={
        canManage ? (
          <>
            <button className="btn btn-secondary" onClick={onClose}>Close</button>
            <button className="btn btn-primary" onClick={() => onAdd?.(date)}>
              <Icon name="plus" size={13} /> Add note
            </button>
          </>
        ) : (
          <button className="btn btn-secondary" onClick={onClose}>Close</button>
        )
      }
    >
      {notes.length === 0 ? (
        <div className="empty-state" style={{ padding: 16 }}>
          <div className="empty-state-title">No notes for this day</div>
        </div>
      ) : (
        <div className="col gap-md">
          {notes.map((n) => (
            <div key={n.id} className="card" style={{ borderLeft: "3px solid var(--warning)" }}>
              <div className="card-body col gap-sm">
                <div className="row" style={{ justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
                  <div className="t-primary fw-600">{n.title}</div>
                  {canManage && (
                    <div className="row gap-sm">
                      <button className="icon-btn" title="Edit" onClick={() => onEdit?.(n)}><Icon name="edit" size={13} /></button>
                      <button className="icon-btn" title="Delete" style={{ color: "var(--danger)" }} onClick={() => onDelete?.(n)}>
                        <Icon name="trash" size={13} />
                      </button>
                    </div>
                  )}
                </div>
                <div className="text-xs t-muted">
                  {formatDate(n.start_date)} → {formatDate(n.end_date)}
                  {n.employee?.name ? ` · ${n.employee.name}` : ""}
                </div>
                {n.description && (
                  <div style={{ whiteSpace: "pre-wrap", fontSize: 13 }}>{n.description}</div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </Drawer>
  );
}
